wbApp.controller('ContractTemplatesCtrl', ['$scope', '$modal', '$translate', '$filter', '$timeout', '$q', 'contractTemplateSvc',
'messageBoxSvc',
function ($scope, $modal, $translate, $filter, $timeout, $q, contractTemplateSvc, messageBoxSvc) {

    $scope.model = {
        templateData: null
    };
    
    $scope.modelOrig = null;
    
    var htmlEditorComponent = null;
    $scope.contractTemplateId = null;
    
    function setContractTemplateId(newId) {
        if ($scope.contractTemplateId !== newId) {
            $scope.contractTemplateId = newId;
        }
        if (!!htmlEditorComponent) {
            htmlEditorComponent.option("readOnly", !$scope.contractTemplateId);
        }
    }


    var modelWasModified = false;
    $scope.modelIsUnchanged = function () {
        
        return !modelWasModified;

    };
    
    function setVariables(variables) {
        if (!!htmlEditorComponent) {
            htmlEditorComponent.option("variables.dataSource", variables);
        }        
    }

    function loadData() {
        if (!$scope.contractTemplateId) {
            $scope.modelOrig = {
                templateData: null
            };
            $scope.model = {
                templateData: null
            };
            modelWasModified = false;
            setVariables([]);
        } else {
            let model = contractTemplateSvc.getById($scope.contractTemplateId);
            model.$promise.then(function () {
                let variables = contractTemplateSvc.getVariablesByType(model.contractTemplateType);
                variables.$promise.then(function() {
                    $scope.model = model;
                    $scope.modelOrig = angular.copy($scope.model);
                    modelWasModified = false;
                    setVariables(variables);
                    htmlEditorComponent.endUpdate();
                });
            });
        }

        if (!!htmlEditorComponent) {
            htmlEditorComponent.option("readOnly", !$scope.contractTemplateId);
        }
    }

    $scope.$on('refreshData', function (e, data) {
        $scope.onReloadTemplate();
    });
    
    $scope.onReloadTemplate = function() {
        if (!$scope.modelIsUnchanged()) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_CONFIRMATION',
                message: $translate.instant('TXT_CONFIRM_CONTRACT_TEMPLATE_RELOAD_DATA'),
                buttons: [{
                    text: 'TXT_BTN_NO'
                }, {
                    text: 'TXT_BTN_YES',
                    callback: loadData
                }]
            });
        } else {
            loadData();
        }
    }
    
    $scope.onTemplateSelected = function() {
        if (!$scope.modelIsUnchanged() && !!$scope.modelOrig) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_CONFIRMATION',
                message: $translate.instant('TXT_CONFIRM_LOAD_TEMPLATE_MODIFIED'),
                buttons: [{
                    text: 'TXT_BTN_NO',
                    callback: function() {
                        setContractTemplateId($scope.modelOrig.id);
                    }
                }, {
                    text: 'TXT_BTN_YES',
                    callback: loadData
                }]
            });            
        } else {
            loadData();
        }
    }
    
    $scope.onNewTemplate = function() {

        function showNewDialog() {
            dialogPromise.$promise.then(function () {
                dialogPromise.$scope.model = null;
                dialogPromise.$scope.onSaveSuccessful = function(model) {
                    $scope.$broadcast('refreshContractTemplateCombo', { id: model.id });
                    setContractTemplateId(model.id);
                    loadData();
                };
                dialogPromise.show();
            });
        }
        
        if (!$scope.modelIsUnchanged() && !!$scope.modelOrig) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_CONFIRMATION',
                message: $translate.instant('TXT_CONFIRM_NEW_TEMPLATE_MODIFIED'),
                buttons: [{
                    text: 'TXT_BTN_NO'
                }, {
                    text: 'TXT_BTN_YES',
                    callback: showNewDialog
                }]
            });
        } else {
            showNewDialog();
        }
    }
    
    $scope.onRenameTemplate = function() {
        dialogPromise.$promise.then(function () {
            dialogPromise.$scope.model = angular.copy($scope.model);
            dialogPromise.$scope.onSaveSuccessful = function(model) {
                $scope.$broadcast('refreshContractTemplateCombo', { id: model.id });
                setContractTemplateId(model.id);
                loadData();
            };
            dialogPromise.show();
        });        
    }

    $scope.onSaveTemplate = function() {
        contractTemplateSvc.update($scope.model).$promise.then(function(model) {
            $scope.model = model;
            $scope.modelOrig = angular.copy($scope.model);
            modelWasModified = false;

        });
    }

    $scope.onDeleteTemplate = function() {
        
        function deleteTemplate() {
            contractTemplateSvc.remove($scope.model.id).$promise.then(function() {
                $scope.$broadcast('refreshContractTemplateCombo', { });
                $scope.contractTemplateId = null;
                loadData();
            });
        }
        
        if (!$scope.modelIsUnchanged() && !!$scope.modelOrig) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_CONFIRMATION',
                message: $translate.instant('TXT_CONFIRM_DELETE_TEMPLATE_MODIFIED'),
                buttons: [{
                    text: 'TXT_BTN_NO'
                }, {
                    text: 'TXT_BTN_YES',
                    callback: deleteTemplate
                }]
            });
        } else {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_CONFIRMATION',
                message: $translate.instant('TXT_CONFIRM_DELETE_TEMPLATE_UNMODIFIED'),
                buttons: [{
                    text: 'TXT_BTN_NO'
                }, {
                    text: 'TXT_BTN_YES',
                    callback: deleteTemplate
                }]
            });
        }        
    }
    
    $scope.onGeneratePreview = function(id) {
        contractTemplateSvc.update($scope.model).$promise.then(function(model) {
            $scope.model = model;
            $scope.modelOrig = angular.copy($scope.model);
            modelWasModified = false;
            window.open("restapi/contract-templates/" + id + "/preview", '_blank');
        });
        
     //   $("#dataDownloadIFrame").remove();
     //   $("body").append("<iframe id='dataDownloadIFrame' src='restapi/contract-templates/" + id + "/preview' style='height: 0;' ></iframe>");        
    }
    
    $scope.htmlEditorOptions = {
        width: "100%",
        height: "100%",
        valueType: "html",
        readOnly: true,
        toolbar: {
            items: [
                "undo",
                "redo",
                "separator",
                {
                    name: "size",
                    acceptedValues: ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"]
                },
                {
                    name: "font",
                    acceptedValues: ["Arial", "Georgia", "Tahoma", "Times New Roman", "Verdana"]
                },
                "separator",
                "bold",
                "italic",
                "strike",
                "underline",
                "separator",
                "alignLeft",
                "alignCenter",
                "alignRight",
                "alignJustify",
                "separator",
                "orderedList",
                "bulletList",
                "separator",
                {
                    name: "header",
                    acceptedValues: [false, 1, 2, 3, 4, 5]
                },
                "separator",
                "color",
                "background",
                "separator",
                "link",
                "image",
                "separator",
                "clear",
                "codeBlock",
                "blockquote",
                "separator",
                "insertTable",
                "deleteTable",
                "insertRowAbove",
                "insertRowBelow",
                "deleteRow",
                "insertColumnLeft",
                "insertColumnRight",
                "deleteColumn",
                "cellProperties",
                "tableProperties",
                "variable"
            ],
            multiline: true
        },
        tableContextMenu: {
            enabled: true
        },
        mediaResizing: {
            enabled: true
        },
        allowSoftLineBreak: true,
        // Template reload or show preview generates an error and break the editor. Probably DevExpress issue
        // tableResizing: {
        //   enabled: true  
        // },
        variables: {
            dataSource: [],
            escapeChar: ["", ""]
        },
        bindingOptions: {
            value: "model.templateData"
        },
        onContentReady: function (e) {
                htmlEditorComponent = e.component;
        },
        onValueChanged: function (e) {
            if (e.event !== undefined) {
                modelWasModified = true;
            }
        },
        customizeModules: function (config) {
            config.history = {
                delay: 0,
                maxStack: 5000
            };
        }
    }

    var dialogPromise = $modal({
        templateUrl: 'activities/contract-templates/contract-template-detail-dialog.html',
        show: false,
        scope: $scope.$new()
    });
}]);
